const UPDATED = "julho de 2026";

export const LEGAL = {
  privacidade: {
    slug: "privacidade",
    title: "Política de Privacidade",
    intro:
      "Esta Política de Privacidade descreve como o site darleiguiarj.com.br, mantido por Darlei — Guia de Turismo credenciado (Cadastur 19.967376.16-7) —, trata as informações de seus visitantes, em conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018 — LGPD).",
    updated: UPDATED,
    sections: [
      {
        title: "1. Quais dados coletamos",
        paragraphs: [
          "Este site não possui formulários de cadastro, área de login nem realiza pagamentos online. Não solicitamos nem armazenamos dados pessoais diretamente pelo site.",
          "Ao navegar, dados técnicos e estatísticos podem ser coletados automaticamente por meio de cookies e ferramentas de análise (como páginas visitadas, tempo de permanência, tipo de dispositivo, navegador e região aproximada), de forma agregada e sem identificação individual.",
          "Ao clicar em um botão de WhatsApp, você é direcionado ao aplicativo WhatsApp (Meta Platforms). As informações que você compartilhar na conversa (nome, datas de viagem, número de pessoas, hospedagem) são utilizadas exclusivamente para atender à sua solicitação e organizar o passeio.",
        ],
      },
      {
        title: "2. Cookies e Google Analytics",
        paragraphs: [
          "Utilizamos o Google Analytics (Google LLC) para entender como o site é utilizado e melhorar a experiência dos visitantes. Essa ferramenta usa cookies e pode registrar eventos como cliques nos botões de contato.",
          "Você pode desativar os cookies nas configurações do seu navegador ou instalar o complemento de desativação do Google Analytics (https://tools.google.com/dlpage/gaoptout). A desativação não impede o uso do site.",
          "Para mais informações sobre o tratamento de dados pelo Google, consulte https://policies.google.com/privacy.",
        ],
      },
      {
        title: "3. Finalidade e base legal",
        paragraphs: [
          "Os dados tratados têm como finalidade: (a) responder a solicitações de informação e reserva; (b) organizar e executar os passeios contratados; (c) analisar estatísticas de uso do site.",
          "O tratamento se fundamenta no legítimo interesse (art. 7º, IX, LGPD), na execução de contrato ou procedimentos preliminares (art. 7º, V) e, quando aplicável, no consentimento do titular (art. 7º, I).",
        ],
      },
      {
        title: "4. Compartilhamento",
        paragraphs: [
          "Não vendemos nem comercializamos dados pessoais. Informações estritamente necessárias (como nome e quantidade de participantes) podem ser compartilhadas com fornecedores envolvidos na execução do passeio — por exemplo, para compra de ingressos de atrações ou serviço de transporte.",
          "Serviços de terceiros utilizados pelo site: Google Analytics (estatísticas), Google Fonts (tipografia), WhatsApp/Meta (contato) e Instagram/Meta (link para perfil). Cada um possui política de privacidade própria.",
        ],
      },
      {
        title: "5. Armazenamento e segurança",
        paragraphs: [
          "As conversas de WhatsApp são mantidas apenas pelo tempo necessário ao atendimento e à execução do serviço, bem como ao cumprimento de obrigações legais. O site é servido exclusivamente por conexão segura (HTTPS).",
        ],
      },
      {
        title: "6. Seus direitos",
        paragraphs: [
          "Nos termos do art. 18 da LGPD, você pode solicitar a qualquer momento: confirmação da existência de tratamento, acesso, correção, anonimização, portabilidade ou eliminação dos seus dados, além de revogar o consentimento.",
          "Para exercer seus direitos, entre em contato pelo WhatsApp +55 21 98861-9303 ou pelo Instagram @darleiguiarj.",
        ],
      },
      {
        title: "7. Alterações desta política",
        paragraphs: [
          "Esta política pode ser atualizada para refletir mudanças legais ou operacionais. A versão vigente estará sempre disponível nesta página, com a data da última atualização.",
        ],
      },
    ],
  },
  termos: {
    slug: "termos",
    title: "Termos de Uso",
    intro:
      "Ao acessar o site darleiguiarj.com.br e contratar os serviços de guia de turismo de Darlei (Cadastur 19.967376.16-7), você concorda com os termos abaixo. Leia com atenção.",
    updated: UPDATED,
    sections: [
      {
        title: "1. Natureza do serviço",
        paragraphs: [
          "O site tem caráter informativo e apresenta o catálogo de experiências guiadas no Rio de Janeiro. Nenhuma contratação é concluída diretamente pelo site: toda consulta, reserva e pagamento ocorre por meio do WhatsApp, após contato direto com o guia.",
          "Os serviços são prestados por guia de turismo credenciado no Ministério do Turismo (Cadastur), conforme a Lei nº 8.623/1993.",
        ],
      },
      {
        title: "2. Valores e o que está incluso",
        paragraphs: [
          "Os valores exibidos são por pessoa, em reais (R$), e podem ser atualizados sem aviso prévio até a confirmação da reserva. Cada passeio possui um valor mínimo de reserva, indicado no catálogo.",
          "Os itens inclusos e não inclusos de cada experiência estão descritos na respectiva página do passeio. Salvo indicação em contrário, refeições (exceto o café da manhã de cortesia), bebidas e gastos pessoais não estão incluídos.",
        ],
      },
      {
        title: "3. Reserva e sinal",
        paragraphs: [
          "A reserva é confirmada somente após o pagamento do sinal, cujo valor e condições são informados pelo WhatsApp de acordo com o valor total da reserva. Até a confirmação do sinal, datas e horários não ficam garantidos.",
          "O saldo restante é pago conforme combinado no momento da reserva.",
        ],
      },
      {
        title: "4. Cancelamento, remarcação e clima",
        paragraphs: [
          "Cancelamentos e remarcações seguem as condições informadas por escrito no momento da reserva. Valores já destinados à compra de ingressos, reservas ou outros custos de terceiros podem estar sujeitos às regras específicas de cada fornecedor.",
          "Em caso de condições climáticas que comprometam a realização ou a segurança da experiência, será avaliada a possibilidade de remarcação sem custo adicional. Atrações podem fechar ou alterar horários por decisão de seus administradores, situação alheia ao guia.",
          "A ordem das paradas pode ser ajustada conforme clima, trânsito e movimento nas atrações, sempre buscando a melhor experiência.",
        ],
      },
      {
        title: "5. Responsabilidades do participante",
        paragraphs: [
          "O participante deve apresentar documento de identificação quando exigido pelas atrações, seguir as orientações de segurança do guia e respeitar os horários combinados. Atrasos podem reduzir o tempo em determinadas paradas.",
          "O participante é responsável por seus pertences pessoais e por informar previamente restrições de saúde ou mobilidade relevantes para o passeio.",
        ],
      },
      {
        title: "6. Propriedade intelectual",
        paragraphs: [
          "Textos, marca, logotipo e fotografias de autoria própria exibidos neste site são protegidos por direitos autorais e não podem ser reproduzidos sem autorização. Algumas imagens ilustrativas são provenientes de bancos de imagens licenciados.",
        ],
      },
      {
        title: "7. Legislação e contato",
        paragraphs: [
          "Estes termos são regidos pelas leis da República Federativa do Brasil, incluindo o Código de Defesa do Consumidor (Lei nº 8.078/1990). Fica eleito o foro da Comarca do Rio de Janeiro/RJ para dirimir eventuais controvérsias.",
          "Dúvidas sobre estes termos: WhatsApp +55 21 98861-9303.",
        ],
      },
    ],
  },
};
